import { Component } from 'preact';
import ClassNames from "classnames";
import { format, getDayName } from "../../util/DateTimeUtils";
import { FORMAT_MASKS } from "../../constants/constants";
import StringWrapper from "../../util/wrapper/StringWrapper";
import { greenChoiceLogo } from "../../constants/icons";
import { isDateGreenForOption } from "../../util/GreenChoiceUtils";
import { getCurrentTranslation } from "../../../i18n/I18nResolver";
import { handleTabArrowKeyPress } from "../../util/KeyboardNavigationUtils";

const $ = window.jQuery;

export default class SelectDayCarousel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            canScrollLeft: false,
            canScrollRight: false
        };
    }

    componentDidMount = () => {
        window.addEventListener("resize", () => {
            this.updateDaySelectCompact();
        });

        this.updateDaySelectCompact();
        // this.scrollToGreenChoice(); // Uncomment it if you want to see GC magic =)
    };

    scrollToGreenChoice = () => {
        const scrollsToGreenDay = this.checkAmountOfRightScrollsNeeded();
        if (!scrollsToGreenDay || scrollsToGreenDay <= 0) {
            return;
        }

        const $container = $('.day-select__navigation');
        if (!$container || $container.length === 0) {
            return;
        }

        const element = $container?.[0];
        const pageWidth = $container.width();
        const currentScrollLeft = $container.scrollLeft();
        const maxScrollLeft = element.scrollWidth - element.clientWidth;
        let target = currentScrollLeft + scrollsToGreenDay * pageWidth;

        if (target > maxScrollLeft) {
            target = maxScrollLeft;
        }
        if (target < 0) {
            target = 0;
        }

        // Scroll to the GreenChoice tab
        $container.scrollLeft(target);
        this.checkButtons();

        // Select the GreenChoice tab
        this.selectFirstGreenChoiceTabIfNeeded();
    };

    checkAmountOfRightScrollsNeeded = () => {
        // find the day-select container
        const containerElement = $('.day-select__navigation')?.[0];
        if (!containerElement) {
            return 0;
        }

        const firstGreenChoiceTabElement = $('.day-select__tab.tab--gc').first()?.[0];
        if (!firstGreenChoiceTabElement) {
            return 0;
        }

        // get viewport positions
        const width = containerElement.clientWidth;
        const scrollLeft = containerElement.scrollLeft;

        const firstGreenChoiceTabBounds = firstGreenChoiceTabElement.getBoundingClientRect();
        const selectElementBounds = containerElement.getBoundingClientRect();

        const tabLeft = firstGreenChoiceTabBounds.left - selectElementBounds.left + scrollLeft;
        const tabRight = tabLeft + $(firstGreenChoiceTabElement).outerWidth(true);
        const viewRight = scrollLeft + width;

        const overflowRight = tabRight - viewRight;

        // count pages needed to reach GC page
        const pages = Math.ceil(overflowRight / width);

        const maxScrollableLeft = containerElement.scrollWidth - width;
        const remaining = Math.max(0, maxScrollableLeft - scrollLeft);
        const maxPages = Math.ceil(remaining / width);

        // prevent over scrolling
        return Math.min(pages, maxPages);
    };

    selectFirstGreenChoiceTabIfNeeded = () => {
        const firstGcTab = $('.day-select__tab.tab--gc').first();
        if (!firstGcTab || firstGcTab.length === 0) {
            return;
        }

        const id = firstGcTab.attr('id') || '';
        const match = id.match(/day-picker__btn--(\d+)/);
        if (!match) {
            return;
        }

        const index = parseInt(match[1], 10);
        const {activeGroup, onSelectGroup} = this.props;
        if (!Number.isInteger(index)) {
            return;
        }

        if (index !== activeGroup) {
            onSelectGroup(index);
        }
    };

    updateDaySelectCompact() {
        const daySelectWidth = $('.day-select__navigation').width();
        const containerSize = 425; // 425px is minimal size to correct displaying styles on the day select carousel
        const daySelectCompact = daySelectWidth < containerSize;

        const visibleTabs = daySelectCompact ? 3 : 4;
        const canScrollRight = this.props.optionGroups && this.props.optionGroups.length > visibleTabs;

        this.setState({
            daySelectCompact,
            canScrollRight
        });
    }

    scrollLeft = () => {
        let checkButtons = this.checkButtons;
        let $container = $('.day-select__navigation');
        let currentScroll = $container.scrollLeft();
        let width = $container.width();

        $container.animate(
            {
                scrollLeft: currentScroll - width
            },
            {
                duration: 200,
                complete: function () {
                    checkButtons();
                }
            }
        );
    };

    scrollRight = () => {
        let checkButtons = this.checkButtons;
        let $container = $('.day-select__navigation');
        let currentScroll = $container.scrollLeft();
        let width = $container.width();

        $container.animate(
            {
                scrollLeft: currentScroll + width
            },
            {
                duration: 200,
                complete: function () {
                    checkButtons();
                }
            }
        );
    };

    checkButtons = () => {
        const {canScrollLeft, canScrollRight} = this.state;

        let $container = $('.day-select__navigation');
        let $listing = $('.day-select__listing');
        let innerWidth = $listing[0].scrollWidth;
        let width = $container.width();
        let margin = 10;
        let maxScroll = innerWidth - width - margin;
        let currentScroll = $container.scrollLeft();

        if (currentScroll <= 0) {
            this.setState({
                canScrollLeft: false
            });
        }

        if (currentScroll > 0 && !canScrollLeft) {
            this.setState({
                canScrollLeft: true
            });
        }

        if (currentScroll >= maxScroll) {
            this.setState({
                canScrollRight: false
            });
        }

        if (currentScroll < maxScroll && !canScrollRight) {
            this.setState({
                canScrollRight: true
            });
        }
    };

    handleKeyDown = (e) => {
        const {activeGroup, onSelectGroup} = this.props;
        const DAY_PICKER_BTN_PREFIX = 'day-picker__btn--';
        const TAB_SELECTOR = '[role="tab"][id^="' + DAY_PICKER_BTN_PREFIX + '"]';
        const ARROW_RIGHT = 'ArrowRight';
        const ARROW_LEFT = 'ArrowLeft';

        const result = handleTabArrowKeyPress(
            e,
            activeGroup,
            TAB_SELECTOR
        );

        if (!result) {
            return;
        }

        const nextTabId = parseInt(result.nextTabId.replace(DAY_PICKER_BTN_PREFIX, ''), 10);

        result.nextTabElement.focus();

        onSelectGroup(nextTabId);

        if (result.direction === ARROW_RIGHT && nextTabId > activeGroup) {
            this.scrollRight();
        } else if (result.direction === ARROW_LEFT && nextTabId < activeGroup) {
            this.scrollLeft();
        }
    };

    getGreenChoiceTitle(prefix) {
        const translation = getCurrentTranslation();

        return prefix + '. ' + translation.greenChoice.gcOptionsAvailable;
    }

    render() {
        const {optionGroups, activeGroup, onSelectGroup} = this.props;
        const {canScrollLeft, canScrollRight, daySelectCompact} = this.state;

        return (
            <section className="day-select__slider" role="region" aria-label="Select a day">
                <button
                    className={ClassNames("day-select__slide day-select__slide--previous", {disabled: !canScrollLeft})}
                    aria-label="previous"
                    aria-controls="carousel"
                    onClick={this.scrollLeft}
                    disabled={!canScrollLeft}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" aria-hidden="true" focusable="false">
                        <g fill="none" fill-rule="evenodd">
                            <path d="M20 20H0V0h20z"/>
                            <path className="colorable" fill="#000" fill-rule="nonzero"
                                  d="M11.667 15l1.175-1.175L9.025 10l3.817-3.825L11.667 5l-5 5z"/>
                        </g>
                    </svg>
                    Previous
                </button>

                <nav onScroll={this.checkButtons}
                     className="tabs__navigation day-select__navigation"
                     aria-label="carousel"
                     role="tablist">
                    <ul className="tabs__navigation__listing day-select__listing"
                        role="presentation">

                        {
                            optionGroups && optionGroups.map((group, index) => {
                                const tabSelected = index === activeGroup;
                                const options = group.groupOptions;
                                const selectedOption = group.groupOptions.find(o => o.checked);
                                const date = format(group.date, FORMAT_MASKS.DAY_MONTH);

                                const anyOptionIsGreenOnDate = !!options?.find(o => isDateGreenForOption(group.date, o));
                                const dateGreenForSelectedOption = isDateGreenForOption(group.date, selectedOption);
                                const greenChoiceStyles = ClassNames(
                                    {"tab--gc-selected": tabSelected && dateGreenForSelectedOption},
                                    {"tab--gc": anyOptionIsGreenOnDate}
                                );

                                const tabButtonClassName = ClassNames(greenChoiceStyles,
                                    "tabs__navigation__tab day-select__tab tab", {"tab--selected": tabSelected});
                                let onClick = () => onSelectGroup(index);

                                const liClassName = ClassNames("tabs__navigation__item",
                                    {"day-select__item": !daySelectCompact},
                                    {"day-select__item-compact": daySelectCompact}
                                );

                                return (
                                    <li className={liClassName} role="presentation">
                                        <button type="button"
                                                role="tab"
                                                id={"day-picker__btn--" + index}
                                                aria-controls={"day-picker__panel--" + index}
                                                aria-selected={tabSelected}
                                                tabIndex={tabSelected ? 0 : -1}
                                                className={tabButtonClassName}
                                                onClick={onClick}
                                                onKeyDown={this.handleKeyDown}>
                                            <span className="paazl-delimiter">
                                                <StringWrapper additionalClassName="tab__title"
                                                               content={getDayName(group.date)}/>
                                                <StringWrapper additionalClassName="tab__date"
                                                               ariaLabel={anyOptionIsGreenOnDate ? this.getGreenChoiceTitle(date) : date}
                                                               content={date}/>
                                            </span>
                                            {
                                                anyOptionIsGreenOnDate &&
                                                <div className={'button__logo--gc'}>
                                                    {greenChoiceLogo}
                                                </div>
                                            }
                                        </button>
                                    </li>
                                );
                            })
                        }

                    </ul>
                </nav>

                <button className={ClassNames("day-select__slide day-select__slide--next", {disabled: !canScrollRight})}
                        aria-label="next"
                        aria-controls="carousel"
                        onClick={this.scrollRight}
                        disabled={!canScrollRight}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" aria-hidden="true" focusable="false">
                        <g fill="none" fill-rule="evenodd">
                            <path d="M0 0h20v20H0z"/>
                            <path className="colorable" fill="#000" fill-rule="nonzero"
                                  d="M8.333 5L7.158 6.175 10.975 10l-3.817 3.825L8.333 15l5-5z"/>
                        </g>
                    </svg>
                    Next
                </button>
            </section>
        );
    }
}